/**
 * Подтверждение выбора фракции в окне выбора рейтингового лобби (после банов,
 * до автостарта). Общие правила сервера и клиента.
 *
 * Нажатие на фракцию только сообщает выбор серверу (SELECT_FACTION) — его
 * можно менять сколько угодно. Решение игрок фиксирует кнопкой «Подтвердить
 * выбор» (CONFIRM_FACTION_SELECTION), и матч досрочно стартует, только когда
 * готовы все: живые игроки — подтвердили выбор, боты и ИИ промо-матча — просто
 * выбрали фракцию (их выбор и есть решение). Не успел подтвердить до конца
 * отсчета — играет тем, что выбрал; не выбрал ничего — случайной незабаненной.
 *
 * Готовность видна всем (метка «Готов»), а сам выбор — нет: пик соперника до
 * старта матча тайна.
 */

/**
 * Нужно ли игроку подтверждать выбор. Ботам (и неявным — сервер знает, что
 * это боты) и ИИ промо-матча — нет: их выбор окончательный сразу, а
 * готовность неявного бота появляется вместе с его выбором — с той же
 * человекоподобной задержкой, что и сам выбор.
 */
export const checkIfFactionConfirmRequired = (player) => Boolean(player) && !player.isBot && !player.isAi;

/**
 * Готов ли игрок к старту: выбрал фракцию и, если это живой игрок, подтвердил.
 *
 * @param {Object} player
 * @param {Array<string>|Set<string>} confirmedIds - кто подтвердил выбор
 */
export const checkIfRankFactionReady = (player, confirmedIds = []) => {
  if (!player?.factionId) {
    return false;
  }
  if (!checkIfFactionConfirmRequired(player)) {
    return true;
  }
  const confirmed = confirmedIds instanceof Set ? confirmedIds : new Set(confirmedIds);
  return confirmed.has(player.id);
};

/** Id готовых к старту — для метки «Готов» у всех участников лобби */
export const getRankFactionReadyIds = ({players = [], confirmedIds = []} = {}) => {
  const confirmed = new Set(confirmedIds);
  return players.filter((player) => checkIfRankFactionReady(player, confirmed)).map((player) => player.id);
};

/** Готовы ли все — условие досрочного старта рейтингового матча. Пустой состав — нет */
export const checkIfAllRankFactionsReady = ({players = [], confirmedIds = []} = {}) => {
  if (players.length === 0) {
    return false;
  }
  const confirmed = new Set(confirmedIds);
  return players.every((player) => checkIfRankFactionReady(player, confirmed));
};
